module.exports = __webpack_public_path__ + "static/media/volume.81650131.svg";